module.exports = __webpack_public_path__ + "img/unitedstates.940000fa.svg";